import { BMButton, BMPopup, BMText } from "@traveloka/district-bloom";
import { useMemo } from "react";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../../utils";

type Props = {
  items?: string[];
  visible?: boolean;
  loading?: boolean;
  onClose?: () => void;
  onContinue?: () => void;
};

export default function InsuranceErrorModal({
  items,
  visible = true,
  onClose = () => {},
  onContinue = () => {},
}: Props) {
  const isPartial = items && items.length > 0;
  const { CorporateFlightPrebookForm: cr, CorporateCommon: cc } =
    useMobileContentResource();

  const { title, description } = useMemo(() => {
    if (isPartial) {
      return {
        title: cr.submitInsurancePartialErrorModalTitle,
        description: formatMessage(
          cr.submitInsurancePartialErrorModalDescription,
          {
            items: items?.join(", "),
          }
        ),
      };
    }
    return {
      title: cr.submitInsuranceErrorModalTitle,
      description: cr.submitInsuranceErrorModalDescription,
    };
  }, [isPartial, items, cr]);
  return (
    <BMPopup
      dismissible={false}
      isVisible={visible}
      onPopupClose={() => {}} // Disable default close on overlay press because dismissible is false
      title={title}
    >
      <BMView spacing="lg">
        <BMText variant="paragraphNormal">{description}</BMText>
        <BMView spacing="sm">
          <BMView>
            <BMButton
              size="LARGE"
              stretchable
              onPress={onClose}
              label={cc.goBackText}
            />
          </BMView>
          <BMView>
            <BMButton
              size="LARGE"
              stretchable
              onPress={onContinue}
              label={cc.continueText}
            />
          </BMView>
        </BMView>
      </BMView>
    </BMPopup>
  );
}
